module.exports = "<h2 id=\"faq-summary\">Accès rapide aux thématiques</h2>\n<ul>\n  <li tabindex=\"0\"\n    *ngFor=\"let category of categories\"\n    (click)=\"scrollToCategory(category.id)\"\n    class=\"btn btn-link active\"\n    role=\"button\">\n    {{ category.title }}\n  </li>\n</ul>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/faq/faq-summary/faq-summary.component.html
// module id = 800
// module chunks = 0